module.exports = __webpack_public_path__ + "1d1e9b5c99e74878fd03209cbb81749d.svg";